import { Text, List, Link } from 'basis';
import { byCountry } from 'utils';
import { State } from 'types';
import { FormData } from 'components';
import { IconWrapper } from './styles';
import { DocUpload, UploadMethods } from 'doc-upload';
import { toDocUploadProps } from './toDocUploadProps';
import { BANK_CONNECT_URLS_AU, BANK_CONNECT_URLS_NZ } from './utils';
import { ReferenceField } from './Fields';
import { PdfIcon } from 'components/icons';
import { Title } from 'components/page-title/PageTitle';

type UploadBankStatementProps = { state: State, formData: FormData, methodsRef: React.MutableRefObject<UploadMethods | undefined> };
export function UploadBankStatements(props: UploadBankStatementProps) {
  return byCountry(props.state, {
    au: <UploadBankStatementAU {...props} />,
    nz: <UploadBankStatementNZ {...props} />,
  });
}

function UploadBankStatementAU({ state, formData, methodsRef }: UploadBankStatementProps) {
  return (
    <>
      <Title>Upload your bank statements</Title>
      <IconWrapper>
        <PdfIcon width="49" height="61"/>
        <Text margin="0 0 0 6">For fast processing, upload your bank statements in PDF file format.</Text>
      </IconWrapper>
      <ReferenceField />
      <div>
        <Text>
          <strong>All documents must contain your full legal name.</strong>
        </Text>
        <List margin="2 0 0 0">
          <List.Item>Show your BSB, account number, and account holder's full legal name</List.Item>
          <List.Item>Cover a minimum of two months of income history</List.Item>
          <List.Item>Ensure your most recent pay entry is visible</List.Item>
          <List.Item>Clearly display deposit amounts and dates</List.Item>
          <List.Item>Include identifiable references for the income source (e.g., Employer or ACN/ABN, Centerlink, rental agency)</List.Item>
          <List.Item>Be a clear screenshot, PDF, or photo of the actual bank statement or transaction history</List.Item>
        </List>
      </div>
      <DocUpload {...toDocUploadProps({ state, formData, methodsRef })} />
      <Text margin="2 0 0 0">
        By clicking 'Submit' you agree to the <Link href={BANK_CONNECT_URLS_AU.TERMS_AND_CONDITIONS} newTab={true}>Illion's Bank Statements Terms & Conditions</Link> and <Link href={BANK_CONNECT_URLS_AU.PRIVACY_POLICY} newTab={true}>Privacy Policy</Link>.
      </Text>
    </>
  );
}

function UploadBankStatementNZ({ state, formData, methodsRef }: UploadBankStatementProps) {
  return (
    <>
      <Title>Upload your bank statements</Title>
      <IconWrapper>
        <PdfIcon width="49" height="61"/>
        <Text>
          For fast processing, upload your bank statements in PDF file format.
        </Text>
      </IconWrapper>
      <ReferenceField />
      <div>
        <Text>
          <strong>All documents must contain your full legal name.</strong>
        </Text>
        <br />
        <List>
          <List.Item>Your bank, branch, account number & account name</List.Item>
          <List.Item>Two months of income payments, ensure your most recent pay entry is visible</List.Item>
          <List.Item>Employer's name corresponding to the deposits</List.Item>
        </List>
      </div>
      <DocUpload {...toDocUploadProps({ state, formData, methodsRef })} />
      <Text margin="2 0 0 0">
        By clicking 'Submit' you agree to the <Link href={BANK_CONNECT_URLS_NZ.TERMS_AND_CONDITIONS} newTab={true}>Illion's Bank Statements Terms & Conditions</Link> and <Link href={BANK_CONNECT_URLS_NZ.PRIVACY_POLICY} newTab={true}>Privacy Policy</Link>.
      </Text>
    </>
  );
}
